import React, { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil'
import {
  Modal, Table, Row, Col, Descriptions, Spin,
} from 'antd'
import { format, parse } from 'date-fns'
import NumberFormat from 'react-number-format'

import { fetch } from '../../utils/fetch'
import { netPriceState, sumPaymentState } from '../../store/atoms'

const { Column } = Table

const PaymentModal = ({
  visible, onSuccess, onCancel, soNumber,
}) => {
  const [loading, setLoading] = useState(true)
  // const [sumPayment, setSumPayment] = useState(0)
  const [paymentList, setPaymentList] = useState([])
  const [netPrice] = useRecoilState(netPriceState)
  const [sumPayment, setSumPayment] = useRecoilState(sumPaymentState)

  const getPayment = () => {
    setLoading(true)
    fetch({
      url: `/payment/${soNumber}`,
    }).then((res) => {
      if (res.data?.success) {
        setSumPayment(res.data?.data?.sumPayment)
        setPaymentList(res.data?.data?.payment)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    if (soNumber) getPayment()
  }, [visible, soNumber])

  const RenderType = (type) => {
    if (type === 'DD') return 'Payment Document'
    if (type === 'DJ') return 'Reverse Payment Document'
    if (type === 'DC') return 'Credit Note Document'
    if (type === 'DK') return 'Reverse Credit Note Document'
    return '-'
  }

  const RenderPrefix = (type) => {
    if (type === 'DD' || type === 'DK') return '+ '
    if (type === 'DJ' || type === 'DC') return '- '
    return ''
  }

  const RenderAmount = (amount, type) => <>{RenderPrefix(type)}<NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={amount || 0} /></>

  if (!soNumber) return ''

  return (

    <Modal
      width={1000}
      title="Payment Transaction"
      visible={visible}
      maskClosable={false}
      cancelText="Cancel"
      onCancel={onCancel}
      footer={null}
    >
      <Spin spinning={loading} tip="Loading...">
        <Table dataSource={paymentList} size="small" pagination={false} bordered>
          <Column title="Transaction Date" dataIndex="BUDAT" key="BUDAT" width="25%" align="center" render={(text) => `${format(parse(text, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy') || '-'}`} />
          <Column title="Channel" dataIndex="type" key="type" align="center" width="25%" render={(text) => RenderType(text)} />
          <Column title="Document No." dataIndex="documentNo" key="documentNo" width="25%" align="center" />
          <Column title="Amount" dataIndex="amount" key="amount" align="right" width="25%" render={(text, record) => RenderAmount(text, record.type)} />
        </Table>
        <Row justify="end" style={{ marginTop: 20 }}>
          <Col span={12}>
            <Descriptions size="small" bordered>
              <Descriptions.Item label="Outstanding balance" span={3} style={{ textAlign: 'right' }}>{netPrice ? <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" suffix=" THB" value={netPrice} /> : '-'}</Descriptions.Item>
              <Descriptions.Item label="Paid" span={3} style={{ textAlign: 'right' }}>{sumPayment ? <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" suffix=" THB" value={sumPayment} /> : '-'}</Descriptions.Item>
              <Descriptions.Item label="Remaining balance" span={3} style={{ textAlign: 'right' }}>
                {
                  Number(netPrice) - Number(sumPayment) !== 0
                    ? <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" suffix=" THB" value={Number(netPrice) - Number(sumPayment)} /> : '-'
                }
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Spin>
    </Modal>

  )
}

export default PaymentModal
